import { render } from "./NewsHeader.vue?vue&type=template&id=9893bbdc&scoped=true"
import script from "./NewsHeader.vue?vue&type=script&lang=js"
export * from "./NewsHeader.vue?vue&type=script&lang=js"

import "./NewsHeader.vue?vue&type=style&index=0&id=9893bbdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9893bbdc"]])

export default __exports__